import '.h{display:grid;}.ssr-plugin'
import '.j{gap:1.5rem;}.ssr-plugin'
import '.js{grid-template-columns:repeat(3, minmax(250px, 1fr));}.ssr-plugin'
import { useQuery } from '@based/sdk/react'
import { styled } from 'inlines'
import { useTranslations } from '@i18n/useLanguage'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import { DiscussionCard } from '@app/components/blocks/discussions/DiscussionCard'
import Column from '@app/components/layout/Column'
import { pages } from '@app/util/links'
import { fullName } from '@app/util/helpers'
import { useRelativeDateFormat } from '@app/util/useDateFormat'
import { navigate } from 'wouter/use-browser-location'
import type { PopularPostViewModel } from 'functions/app/thread/view-popular'
import { getPostedInLabel } from '@app/pages/discussions/discussionsHelpers'

export const DiscussionSection = () => {
  const t = useTranslations().app
  const relativeDate = useRelativeDateFormat()
  const { data, error } = useQuery('thread-view-popular')
  const posts: PopularPostViewModel[] = data ?? []
  if (error) console.error('[DiscussionSection]', error)

  if (posts.length === 0) return null

  return (
    <Column alignItems="stretch">
      <SectionHeader
        title={t.landingPage.prikbordSection.title}
        subtitle={t.landingPage.prikbordSection.subTitle}
        seeMore={t.landingPage.prikbordSection.seeMore}
        toRoute={pages.discussions}
      />
      <styled.div className="h j js"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          }
        }}
      >
        {posts.map((post) => (
          <DiscussionCard
            key={post.id}
            authorName={
              post.author
                ? fullName({
                    firstName: post.author.firstName,
                    lastName: post.author.lastName,
                    middlePart: post.author.middlePart,
                  })
                : ''
            }
            authorAvatar={post.author?.avatar?.src}
            postedIn={getPostedInLabel(post.threads)}
            date={post.createdAt ? relativeDate(new Date(post.createdAt)) : ''}
            content={post.content ?? ''}
            title={post.title ?? undefined}
            likes={post.likes}
            replies={post.replies}
            categories={post.categories}
            media={post.media.map((item) => ({
              src: item.src,
              mimeType: item.mimeType,
              name: item.name,
            }))}
            onClick={() =>
              navigate(`${pages.discussions}?post=${post.id}`)
            }
            style={{
              paddingBottom: '1rem',
            }}
          />
        ))}
      </styled.div>
    </Column>
  )
}
